// IE 2026 09 21 / ODOO-5800 (Igor, скрин блока DETAILS формы ячейки: «показывай статусы в документах как бейджи — как мы делаем это в других полях, например доках; и давай
// попробуем сделать бейджи и для сегментов доков PO DO MO SO … чтобы они легко читались и отделялись друг от дружки и выделялись от бейджа тех же статусов документов»;
// следом: «как и с сегментами доков — предлагаю сделать и с сегментами карт, при этом если в карте есть "Measure type", то показывать его внутри бейджа; и покажи их в списке
// правил (например после id)»): чистая логика бейджей формы ячейки — без Vue и DOM.
// Строка паспорта ячейки (бэк be-ie cell_passport): [подпись, значение, links?, marks?]
//   links — ссылки строки (ie-bio7, be-ie 627c025ec): {kind: 'doc' | 'node' | 'rule', id, segment, version?, title}; title — подстрока значения, по порядку появления;
//   marks — метки бейджей: {kind: 'status' | 'segment' | 'card' | 'alert', id, title, text, css?, measure?, hint?, at?, pos?}; title — подстрока значения, по порядку появления (свой счёт,
//           отдельно от ссылок); метка с at = 'label' относится к подписи строки. Бейдж встаёт НА МЕСТО подстроки title и показывает text.
// Три вида бейджей различаются формой, а не только цветом: статус — пастельная пилюля платформы (.status-chip, цвет — cssClass записи статуса, как в списках документов);
// сегмент документа — плотная прямоугольная метка с заливкой; сегмент карты — контурная метка из двух частей «сегмент | Measure type».
// Семейство цвета — общее у документа и карты одного рода (заказ поставщику и карта закупки — один тон)
import { t, getLanguage, LANGUAGE_DEFAULT } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n; IE 2026 09 25 / ODOO-341407: язык — для бейджа карты (cardTag_text)
const FAMILY = {
    PO: 'purchase', 'PURCHASE-ORDER': 'purchase', 'MAP-Purchases': 'purchase',
    DO: 'transfer', 'DISTR-ORDER': 'transfer', 'MAP-Distr': 'transfer',
    MO: 'manuf', 'MANUF-ORDER': 'manuf', 'MAP-Manuf': 'manuf',
    SO: 'sales', 'SALES-ORDER': 'sales', 'MAP-Sales': 'sales',
    'MAP-Stock': 'stock',
}
export function segTag_family(id) { return FAMILY[String(id || '')] || 'other' }
// короткое имя сегмента карты: 'MAP-Distr' → 'Distr'
export function cardSeg_short(segment) { const s = String(segment || ''); return s.startsWith('MAP-') ? s.slice(4) : s }

// IE 2026 09 21 / ODOO-5800 (Igor: пометка «NOT covered» — сразу за количеством): КОНТРАКТ С ПОЗИЦИЯМИ. Бэк, увидев client.passport_pos, называет место элемента числом pos
// (единицы UTF-16 — индексы строк JavaScript); место берём как есть, когда подстрока на нём совпадает с title. Без pos — прежний поиск первого вхождения после предыдущего
// элемента (названия причин содержат «rule » — по первому вхождению бейдж карты встал бы внутрь названия причины, поэтому прежний бэк держит пометку в конце строки)
function _ranges(value, items) {
    const out = []
    let cur = 0
    for (const it of items) {
        const t = String((it && it.title) || '')
        if (!t) continue
        const p = it.pos
        if (Number.isInteger(p) && p >= 0 && value.substr(p, t.length) === t) { out.push({ from: p, to: p + t.length, it }); cur = Math.max(cur, p + t.length); continue }
        const i = value.indexOf(t, cur)
        if (i < 0) continue
        out.push({ from: i, to: i + t.length, it }); cur = i + t.length
    }
    return out
}
// метка подписи строки (тип документа движения) либо null
export function passportRow_labelMark(row, marksOn = true) {
    if (!marksOn || !Array.isArray(row) || !Array.isArray(row[3])) return null
    return row[3].find(m => m && m.at === 'label' && m.kind) || null
}
// значение строки по кускам: [{text, link, mark}] — mark: на месте куска рисуется бейдж; link: кусок (или бейдж) принадлежит ссылке строки.
// Метка — всегда ОДИН кусок; ссылка у бейджа есть, когда метка целиком лежит внутри ссылки. Без ссылок и меток — один кусок с исходным текстом
export function passportRow_pieces(row, marksOn = true) {
    const value = String((Array.isArray(row) ? row[1] : row) ?? '')
    const links = Array.isArray(row) && Array.isArray(row[2]) ? row[2] : []
    const marks = (marksOn && Array.isArray(row) && Array.isArray(row[3])) ? row[3].filter(m => m && m.at !== 'label' && m.kind) : []
    const lr = _ranges(value, links), mr = _ranges(value, marks)
    if (!lr.length && !mr.length) return [{ text: value, link: null, mark: null }]
    const cuts = new Set([0, value.length])
    for (const r of lr) { cuts.add(r.from); cuts.add(r.to) }
    for (const r of mr) { cuts.add(r.from); cuts.add(r.to) }
    const pts = [...cuts].sort((a, b) => a - b), out = []
    for (let i = 0; i + 1 < pts.length; i++) {
        const a = pts[i], b = pts[i + 1]
        if (b <= a) continue
        const m = mr.find(r => r.from <= a && b <= r.to)
        if (m) {
            if (a !== m.from) continue   // остальные части той же метки: бейдж уже выведен
            const l = lr.find(r => r.from <= m.from && m.to <= r.to)
            out.push({ text: value.slice(m.from, m.to), link: l ? l.it : null, mark: m.it })
            continue
        }
        const l = lr.find(r => r.from <= a && b <= r.to)
        out.push({ text: value.slice(a, b), link: l ? l.it : null, mark: null })
    }
    return out
}
// IE 2026 09 25 / ODOO-341407 (Igor 25.09, скрин формы ячейки под uk: бейдж карты «Purchases | PO. Arrival to BW» — код и английская база): текст левой части бейджа карты.
// Под языком интерфейса не en при известном виде меры карты код сегмента не показывается — бейдж несёт локализованное название вида меры, род карты виден по цвету,
// полное название вида правил — в подсказке; без вида меры — короткое название вида правил по словарю ('Purchases|rule kind' → «Закупівлі»). en — как прежде (код)
export function cardTag_text(segment, measureTitle) {
    const seg = String(segment || '')
    if (!seg) return ''
    if (measureTitle && getLanguage() !== LANGUAGE_DEFAULT) return ''
    return t(cardSeg_short(seg), null, 'rule kind')
}
// бейдж карты для списка правил формы ячейки: {text, measure, family, hint}
export function cardTag(segment, measureTitle, listTitle) {   // IE 2026 09 23 / ODOO-341407: i18n
    const seg = String(segment || '')
    if (!seg) return null
    const measure = String(measureTitle || '')
    const base = String(listTitle || '') || seg
    return { text: cardTag_text(seg, measure), measure, family: segTag_family(seg), hint: measure ? t('{title} · measure type: {measure}', { title: base, measure }) : base }   // IE 2026 09 25 / ODOO-341407: text — cardTag_text
}

// IE 2026 09 24 / ODOO-5800 (Igor, скрины к колонке запасов: «+1 728 / −0», «1 728 (1m 25d)», «+3 024 / −1 870» рвались по строкам): числа паспорта не переносятся —
// пробел-разделитель тысяч («1 728»), пробел между числом и скобкой («1 728 (1m 25d)»), пробелы внутри короткой скобки с цифрами («(1 міс 1 дн)», «(1m / 2m / 2m)») и « / »
// между числами («+3 024 / −1 870», «0 / 900 / 900») → неразрывный пробел U+00A0 (длина строки та же — диапазоны ссылок / меток кусков не сдвигаются; поиск формы NBSP
// нормализует); слова текста переносятся как прежде. Зовут блоки DETAILS · STOCK и WHY THIS PLAN формы ячейки (fe.cellForm.stockSeparate)
// IE 2026 09 25 / ODOO-5800 (Igor: параметры утверждения LBE «как в M03»): время аудита бэка (UTC «YYYY-MM-DD HH:MM[:SS]», как _cells.updated_at) — местное «dd.mm.yyyy hh:mm»,
// как в блоке CORRECTION формы (Dropdown.corr_localTime); не разбирается как дата — как есть
export function passportLocalTime(at) {
    if (!at) return ''
    const s = String(at).trim()
    const d = new Date(s.replace(' ', 'T') + (/(Z|[+-]\d\d:?\d\d)$/.test(s) ? '' : 'Z'))
    if (Number.isNaN(d.getTime())) return s
    const pad = n => String(n).padStart(2, '0')
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

const NBSP = '\u00a0'   // неразрывный пробел
export function passportNoBreak(s) {
    let x = String(s == null ? '' : s)
    if (!/\d/.test(x)) return x
    x = x.replace(/(\d) (?=\d{3}(?!\d))/g, '$1' + NBSP)                                              // разделители тысяч: «12 345 678»
    x = x.replace(/\(([^()]{1,24})\)/g, (m, g) => /\d/.test(g) ? '(' + g.replace(/ /g, NBSP) + ')' : m)   // короткая скобка с цифрами: «(1m 25d)», «(1m / 2m / 2m)»
    x = x.replace(/(\d) (?=\((?=[^()]{0,24}\d)[^()]{1,24}\))/g, '$1' + NBSP)                         // число и его скобка: «1 728 (1m 25d)»
    x = x.replace(/([\d)%]) \/ (?=[+−-]?\d)/g, '$1' + NBSP + '/' + NBSP)                             // пары и тройки чисел: «+1 728 / −0», «0 / 900 / 900»
    return x
}
